import { Utills } from "../../../../../shared/app-configs/utilit";

export interface ProductFormData {
  productInfo: ITCProduct;
  rawMaterialInfo: ITcProductRawMaterialInformation[];
  geographicInfo: ITcProductRawMaterialGeographicInformation[];
  productCertifiedWeightInfo: ITcProductCertifiedWeightInformation[];
  productFacilitiesInfo: ITcProductFacilitiesInformation[];
  productFirstProcessorInfo: ITcProductFirstProcessorInformation[];
  additionalInfo: IAdditionalInfo;
}
export interface Option {
  value: string | number;
  label: string;
}

export const normalizeStringArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
      .map((item) => String(item).trim())
      .filter((item) => item.length > 0);
  }

  if (typeof value === "string" && value.trim()) {
    return [value.trim()];
  }

  return [];
};

export interface ITCProduct {
  tcProductOrderNo: string[];
  tcProductArticleNo: string;
  tcProductProductionDate: string;
  tcProductShipmentDocNo: string[];
  tcProductNumberOfUnits: string;
  tcProductUnitsMetric: string;
  tcProductNetShippingWeight: number;
  tcProductSupplementaryWeight: number;
  tcProductInfoSupplementaryWeight: string;
  tcProductCategoryCode: string;
  tcProductCategoryUserSpecificTerm: string;
  tcProductDetailCode: string;
  tcProductDetailUserSpecificTerm: string;
  tcProductCategoryCodeDescription: string;
  tcProductDetailCodeDescription: string;
}

export interface IAdditionalInfo {
  tcProductInfoFiberLength: string;
  tcProductInfoYarnCount: string;
  tcProductInfoFabricWeightAndConstruct: string;
  tcProductInfoFabricWeightOfFinishedProduct: string;
  tcProductInfoAdditional: string;
  tcProductAdditives: string;
  tcProductAdditivesWeight: number;
  tcProductFeedstock: string[]; // Now array for chip input
  tcProductPercentTextileWaste: string;
  tcProductPackagingFor: string[];
  tcProductGtin: string;
  tcProductReclaimedMaterialSource: string[]; // Now array for chip input
  tcProductInfoTechnicalSpecifications: string;
  tcProductOriginFacilityTeId: string[];
}

export interface ITcProductRawMaterialInformation {
  tcProductRawMaterialCode: string;
  tcProductRawMaterialPercentage: number;
  tcProductRawMaterialUserSpecificTerm: string;
  tcProductRawMaterialCodeDescription: string;
}

export interface ITcProductRawMaterialGeographicInformation {
  tcProductCertifiedRawMaterialCode: string;
  tcProductCertifiedRawMaterialCodeDescription: string;
  tcProductCertifiedRawMaterialWeight: number;
  tcProductCertifiedRawMaterialCountryOrArea: string;
  tcProductCertifiedRawMaterialCountryOrAreaDescription: string;
  tcProductCertifiedRawMaterialStateOrProvince: string;
  tcProductCertifiedRawMaterialStateOrProvinceDescription: string;
}

export interface ITcProductCertifiedWeightInformation {
  tcProductClaimsCategory: string;
  tcProductCertifiedWeight: number;
  tcProductRawMaterialCodeClaimsCategory: string;
  tcProductRawMaterialCodeClaimsCategoryDescription: string;
}

export interface ITcProductFacilitiesInformation {
  tcProductFacilitiesTeId: string;
  tcProductFacilitiesProcessCode: string;
}

export interface ITcProductFirstProcessorInformation {
  tcProductFirstProcessorTeId: string;
  tcProductFirstProcessCode: string;
}

export interface ICertifiedProductDetails {
  tcId: string;
}

// Update mapToPayload function
export const mapToPayload = (data: ProductFormData, tcId: string, productId?: string | null) => {
  return {
    tcId,
    ...(productId ? { productId } : {}),
    tcProductInformation: [
      {
        tcProductOrderNo: Array.isArray(data.productInfo.tcProductOrderNo)
          ? data.productInfo.tcProductOrderNo
          : [data.productInfo.tcProductOrderNo || ""],
        tcProductArticleNo: data.productInfo.tcProductArticleNo || "",
        tcProductProductionDate: data.productInfo.tcProductProductionDate || "",
        tcProductShipmentDocNo: Array.isArray(data.productInfo.tcProductShipmentDocNo)
          ? data.productInfo.tcProductShipmentDocNo
          : [data.productInfo.tcProductShipmentDocNo || ""],
        tcProductNumberOfUnits: data.productInfo.tcProductNumberOfUnits || "0",
        tcProductUnitsMetric: data.productInfo.tcProductUnitsMetric || "",
        tcProductNetShippingWeight: data.productInfo.tcProductNetShippingWeight || 0,
        tcProductSupplementaryWeight: data.productInfo.tcProductSupplementaryWeight || 0,
        tcProductInfoSupplementaryWeight: data.productInfo.tcProductInfoSupplementaryWeight || "",
        tcProductCategoryCode: data.productInfo.tcProductCategoryCode || "",
        tcProductCategoryUserSpecificTerm: data.productInfo.tcProductCategoryUserSpecificTerm || "",
        tcProductDetailCode: data.productInfo.tcProductDetailCode || "",
        tcProductDetailUserSpecificTerm: data.productInfo.tcProductDetailUserSpecificTerm || "",
        tcProductCategoryCodeDescription: data.productInfo.tcProductCategoryCodeDescription || "",
        tcProductDetailCodeDescription: data.productInfo.tcProductDetailCodeDescription || "",
        tcProductRawMaterialInformation: (data.rawMaterialInfo || []).map(item => ({
          tcProductRawMaterialCode: item.tcProductRawMaterialCode || "",
          tcProductRawMaterialPercentage: item.tcProductRawMaterialPercentage || 0,
          tcProductRawMaterialUserSpecificTerm: item.tcProductRawMaterialUserSpecificTerm || "",
          tcProductRawMaterialCodeDescription: item.tcProductRawMaterialCodeDescription || ""
        })),
        tcProductCertifiedRawMaterialGeographicInformation: (data.geographicInfo || []).map(item => ({
          tcProductCertifiedRawMaterialCode: item.tcProductCertifiedRawMaterialCode || "",
          tcProductCertifiedRawMaterialCodeDescription: item.tcProductCertifiedRawMaterialCodeDescription || "",
          tcProductCertifiedRawMaterialWeight: item.tcProductCertifiedRawMaterialWeight || 0,
          tcProductCertifiedRawMaterialCountryOrArea: item.tcProductCertifiedRawMaterialCountryOrArea || "",
          tcProductCertifiedRawMaterialCountryOrAreaDescription: item.tcProductCertifiedRawMaterialCountryOrAreaDescription || "",
          tcProductCertifiedRawMaterialStateOrProvince: item.tcProductCertifiedRawMaterialStateOrProvince || "",
          tcProductCertifiedRawMaterialStateOrProvinceDescription: item.tcProductCertifiedRawMaterialStateOrProvinceDescription || ""
        })),
        tcProductCertifiedWeightInformation: (data.productCertifiedWeightInfo || []).map(item => ({
          tcProductClaimsCategory: item.tcProductClaimsCategory || "",
          tcProductCertifiedWeight: item.tcProductCertifiedWeight || 0,
          tcProductRawMaterialCodeClaimsCategory: item.tcProductRawMaterialCodeClaimsCategory || "",
          tcProductRawMaterialCodeClaimsCategoryDescription: item.tcProductRawMaterialCodeClaimsCategoryDescription || ""
        })),
        tcProductFacilitiesInformation: (data.productFacilitiesInfo || []).map(item => ({
          tcProductFacilitiesTeId: item.tcProductFacilitiesTeId || "",
          tcProductFacilitiesProcessCode: item.tcProductFacilitiesProcessCode || ""
        })),
        tcProductFirstProcessorInformation: (data.productFirstProcessorInfo || []).map(item => ({
          tcProductFirstProcessorTeId: item.tcProductFirstProcessorTeId || "",
          tcProductFirstProcessCode: item.tcProductFirstProcessCode || ""
        })),
        tcProductAdditives: data.additionalInfo.tcProductAdditives || "",
        tcProductAdditivesWeight: data.additionalInfo.tcProductAdditivesWeight || 0,
        tcProductInfoFiberLength: data.additionalInfo.tcProductInfoFiberLength || "",
        tcProductInfoYarnCount: data.additionalInfo.tcProductInfoYarnCount || "",
        tcProductInfoFabricWeightAndConstruct: data.additionalInfo.tcProductInfoFabricWeightAndConstruct || "",
        tcProductInfoFabricWeightOfFinishedProduct: data.additionalInfo.tcProductInfoFabricWeightOfFinishedProduct || "",
        tcProductInfoTechnicalSpecifications: data.additionalInfo.tcProductInfoTechnicalSpecifications || "",
        tcProductFeedstock: data.additionalInfo.tcProductFeedstock || "",
        tcProductPercentTextileWaste: data.additionalInfo.tcProductPercentTextileWaste || "",
        tcProductPackagingFor: normalizeStringArray(data.additionalInfo.tcProductPackagingFor),
        tcProductGtin: data.additionalInfo.tcProductGtin || "",
        tcProductReclaimedMaterialSource: data.additionalInfo.tcProductReclaimedMaterialSource || "",
        tcProductInfoAdditional: data.additionalInfo.tcProductInfoAdditional || "",
        tcProductOriginFacilityTeId: Array.isArray(data.additionalInfo.tcProductOriginFacilityTeId)
          ? data.additionalInfo.tcProductOriginFacilityTeId
          : data.additionalInfo.tcProductOriginFacilityTeId
          ? [String(data.additionalInfo.tcProductOriginFacilityTeId)]
          : []
      }
    ]
  };
};

export const payloadToMap = (payload: any): ProductFormData => {
  Utills.cl(payload, "map");
  
  // Extract the first item from tcProductInformation array
  const productInfo = payload.tcProductInformation?.[0] || {};
  
  return {
    productInfo: {
      tcProductOrderNo: Array.isArray(productInfo.tcProductOrderNo) 
        ? productInfo.tcProductOrderNo 
        : [productInfo.tcProductOrderNo || ""],
      tcProductArticleNo: productInfo.tcProductArticleNo || "",
      tcProductProductionDate: productInfo.tcProductProductionDate || "",
      tcProductShipmentDocNo: Array.isArray(productInfo.tcProductShipmentDocNo) 
        ? productInfo.tcProductShipmentDocNo 
        : [productInfo.tcProductShipmentDocNo || ""],
      tcProductNumberOfUnits: productInfo.tcProductNumberOfUnits || "0",
      tcProductUnitsMetric: productInfo.tcProductUnitsMetric || "",
      tcProductNetShippingWeight: productInfo.tcProductNetShippingWeight?.toString() || "0",
      tcProductSupplementaryWeight: productInfo.tcProductSupplementaryWeight?.toString() || "0",
      tcProductInfoSupplementaryWeight: productInfo.tcProductInfoSupplementaryWeight || "",
      tcProductCategoryCode: productInfo.tcProductCategoryCode || "",
      tcProductCategoryUserSpecificTerm: productInfo.tcProductCategoryUserSpecificTerm || "",
      tcProductDetailCode: productInfo.tcProductDetailCode || "",
      tcProductDetailUserSpecificTerm: productInfo.tcProductDetailUserSpecificTerm || "",
      tcProductCategoryCodeDescription: productInfo.tcProductCategoryCodeDescription || "",
      tcProductDetailCodeDescription: productInfo.tcProductDetailCodeDescription || ""
    },
    rawMaterialInfo: (productInfo.tcProductRawMaterialInformation || []).map((item: any) => ({
      tcProductRawMaterialCode: item.tcProductRawMaterialCode || "",
      tcProductRawMaterialPercentage: item.tcProductRawMaterialPercentage?.toString() || "0",
      tcProductRawMaterialUserSpecificTerm: item.tcProductRawMaterialUserSpecificTerm || "",
      tcProductRawMaterialCodeDescription: item.tcProductRawMaterialCodeDescription || ""
    })),
    geographicInfo: (productInfo.tcProductCertifiedRawMaterialGeographicInfo || []).map((item: any) => ({
      tcProductCertifiedRawMaterialCode: item.tcProductCertifiedRawMaterialCode || "",
      tcProductCertifiedRawMaterialCodeDescription: item.tcProductCertifiedRawMaterialCodeDescription || "",
      tcProductCertifiedRawMaterialWeight: item.tcProductCertifiedRawMaterialWeight?.toString() || "0",
      tcProductCertifiedRawMaterialCountryOrArea: item.tcProductCertifiedRawMaterialCountryOrArea || "",
      tcProductCertifiedRawMaterialCountryOrAreaDescription: item.tcProductCertifiedRawMaterialCountryOrAreaDescription || "",
      tcProductCertifiedRawMaterialStateOrProvince: item.tcProductCertifiedRawMaterialStateOrProvince || "",
      tcProductCertifiedRawMaterialStateOrProvinceDescription: item.tcProductCertifiedRawMaterialStateOrProvinceDescription || ""
    })),
    productCertifiedWeightInfo: (productInfo.tcProductCertifiedWeightInformation || []).map((item: any) => ({
      tcProductClaimsCategory: item.tcProductClaimsCategory || "",
      tcProductCertifiedWeight: item.tcProductCertifiedWeight?.toString() || "0",
      tcProductRawMaterialCodeClaimsCategory: item.tcProductRawMaterialCodeClaimsCategory || "",
      tcProductRawMaterialCodeClaimsCategoryDescription: item.tcProductRawMaterialCodeClaimsCategoryDescription || ""
    })),
    productFacilitiesInfo: (productInfo.tcProductFacilitiesInformation || []).map((item: any) => ({
      tcProductFacilitiesTeId: item.tcProductFacilitiesTeId || "",
      tcProductFacilitiesProcessCode: item.tcProductFacilitiesProcessCode || ""
    })),
    productFirstProcessorInfo: (productInfo.tcProductFirstProcessorInformation || []).map((item: any) => ({
      tcProductFirstProcessorTeId: item.tcProductFirstProcessorTeId || "",
      tcProductFirstProcessCode: item.tcProductFirstProcessCode || ""
    })),
    additionalInfo: {
      tcProductInfoFiberLength: productInfo.tcProductInfoFiberLength || "",
      tcProductInfoYarnCount: productInfo.tcProductInfoYarnCount || "",
      tcProductInfoFabricWeightAndConstruct: productInfo.tcProductInfoFabricWeightAndConstruct || "",
      tcProductInfoFabricWeightOfFinishedProduct: productInfo.tcProductInfoFabricWeightOfFinishedProduct || "",
      tcProductInfoAdditional: productInfo.tcProductInfoAdditional || "",
      tcProductAdditives: productInfo.tcProductAdditives || "",
      tcProductAdditivesWeight: productInfo.tcProductAdditivesWeight || 0,
      tcProductFeedstock: productInfo.tcProductFeedstock || "",
      tcProductPercentTextileWaste: productInfo.tcProductPercentTextileWaste || "",
      tcProductPackagingFor: normalizeStringArray(productInfo.tcProductPackagingFor),
      tcProductGtin: productInfo.tcProductGtin || "",
      tcProductReclaimedMaterialSource: productInfo.tcProductReclaimedMaterialSource || "",
      tcProductInfoTechnicalSpecifications: productInfo.tcProductInfoTechnicalSpecifications || "",
      tcProductOriginFacilityTeId: Array.isArray(productInfo.tcProductOriginFacilityTeId)
        ? productInfo.tcProductOriginFacilityTeId
        : productInfo.tcProductOriginFacilityTeId
        ? [productInfo.tcProductOriginFacilityTeId]
        : []
    }
  };
};

export function transformShipmentDetails(response: any): Option[] {
  if (!response || !Array.isArray(response.tcShipmentConsigneeDetails)) {
    throw new Error("Invalid response format. Expected 'tcShipmentConsigneeDetails' to be an array.");
  }
  return response.data.tcShipmentConsigneeDetails.map((detail: { tcShipmentNo?: string }) => {
    Utills.cl(detail);
    const shipmentNo = detail.tcShipmentNo ?? "";
    return { value: shipmentNo, label: shipmentNo };
  });
}
